<template>
  <div class="container blank-slate-box">
    <h2 class="title is-3 has-text-centered m-t-40">Start your first slide deck:</h2>

    <div class="card-grid">
      <DeckBannerButton @click.native="newDeck" icon="plus" label="Create New" class="secondary" data-cy="new-deck" />
      <DeckBannerButton @click.native="upload" img-src="/logos/powerpoint.svg" label="Upload" class="powerpoint" />
      <DeckBannerButton @click.native="browseTemplates" img-src="/illustrations/rating-click.svg" label="Ready-to-play" class="gray" />
    </div>

    <p class="lower">
      Want to see how it works first? <PlayDemoButton :tracking-data="{location: 'Start Box'}" />
    </p>
  </div>
</template>

<script>
import DeckBannerButton from '~/components/decks/quick-start-banner/DeckBannerButton.vue'
import PlayDemoButton from '~/components/PlayDemoButton.vue'

export default {
  name: 'BlankSlateBox',
  components: { DeckBannerButton, PlayDemoButton },
  mounted () {
    this.posthogCapture('onboard:start_box_shown')
  },
  methods: {
    newDeck () {
      this.posthogCapture('onboard:start_box_blank_click', { click_intent: 'create blank' })
      this.$emit('new-deck')
    },
    upload () {
      this.posthogCapture('onboard:start_box_import_click', { click_intent: 'import deck' })
      this.$emit('upload')
    },
    browseTemplates () {
      this.posthogCapture('onboard:start_box_browse_click', { click_intent: 'browse templates' })
      this.$router.push('/templates')
    }
  }
}
</script>

<style scoped lang="scss">
@import "/assets/css/components";

.blank-slate-box {

  &.container {
    max-width: 800px;
    margin: 0 auto 150px;
  }

  .card {
    width: 14em;
  }

  .card-grid {
    margin-top: 2.5em;
    display: flex;
    gap: 2em;
    justify-content: center;
  }

  .card {
    padding: 2rem;
    background: $white;
    border: 1px solid rgba(229, 234, 236, 0.712);
    border-radius: $border-radius;
    box-shadow: none;;
  }

  .card-header {
    font-size: $font-size-1;
    margin: $margin-3 0 $margin-5;
    font-weight: bold;
    justify-content: center;
    box-shadow: none;
  }

  .card-content {
    display: flex;
    justify-content: space-around;

    > * {
      max-width: 8rem;
    }

    @media(max-width: 600px) {
      flex-direction: column;
      align-items: center;

      > *, .icon.is-large {
        width: 100%!important;
        max-width: 100%;
      }

      > *:not(:last-child) {
        margin-bottom: $margin-5;
      }
    }
  }

  .lower {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    padding-bottom: 0;
    margin-top: 3em;
  }
}
</style>
